import { type GenericElement } from '@modules/editor/src/lib/element';

import { type AIProjectInitializationAnalysisResult } from '$/services/usecases/projects/mapper/editorProject';
import { type EditorComponent } from '$/stores/useCustomEditorStore';

export type EditorView = {
  elements: GenericElement[];
  components: EditorComponent[];
  ai?: { sceneAnalysis?: AIProjectInitializationAnalysisResult };
};

type ProjectVersions = [
  EditorView,
  { version: 1 } & EditorView,
  { version: 2; views: EditorView[] },
];

type MigrationFunctions<T extends readonly unknown[]> = T extends readonly [
  infer First,
  ...infer Rest,
]
  ? Rest extends readonly []
    ? []
    : [(prev: First) => Rest[0], ...MigrationFunctions<Rest>]
  : [];

const migrations: MigrationFunctions<ProjectVersions> = [
  (prev) => ({ ...prev, version: 1 }),
  ({ elements = [], components = [], ...rest }) => ({
    ...rest,
    version: 2,
    views: [{ elements, components }],
  }),
];

export type ProjectData = ProjectVersions extends readonly [
  ...unknown[],
  infer Last,
]
  ? Last
  : ProjectVersions[0];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const migrateProjectData = (data: any): ProjectData => {
  let safeData = { elements: [], components: [], ...data };

  for (let v = safeData.version ?? 0; v < migrations.length; v++) {
    safeData = migrations[v](safeData);
    console.info(
      `Automatically migrated project from version ${v} to ${v + 1}`,
    );
  }

  return safeData;
};
